export const translations = {
  en: {
    header: { tag: "Pet Odor Eliminator Concentrate", buy: "Buy €20" },
    nav: { bottle: "The Bottle", how: "3-Step Mix", surfaces: "Surfaces", reviews: "Reviews", faq: "FAQ", office: "Madrid Office" },
    announcement: ["Free shipping within Spain", "1 bottle makes 3.79 L", "Natural orange oil — safe around pets", "Ships worldwide from Madrid"],
    hero: {
      overline: "Pet Odor Eliminator · Concentrate",
      title: "The Concentrated Odor Assassin.",
      subtitle: "Works on any surface: carpet, tile, turf, and fabric. Our 237 ml cold-pressed orange oil concentrate mixes with plain tap water to make 3.79 litres of high-strength odor eliminator safe for curious paws.",
      stat1v: "237 ML", stat1l: "Makes 3.79 L",
      stat2v: "100%", stat2l: "Natural Oil",
      stat3v: "€20", stat3l: "Ships Worldwide",
      cta: "Order Concentrate · €20",
      shipsNote: "Ships across Europe & worldwide from Madrid",
      chip: "1 bottle → 3.79 L",
      check1: "Pet safe formula", check2: "GMP certified facility", check3: "Cruelty free"
    },
    marquee: ["ELIMINATES PET ODOR", "SMELLS LIKE FRESH ORANGES", "MAKES 3.79 LITRES", "SAFE AROUND PAWS", "SHIPS WORLDWIDE"],
    product: {
      overline: "What the bottle does",
      title: "One Small Bottle. Massive Strength.",
      subtitle: "Stop paying to ship diluted water across borders. Angry Tangerine gives you raw, concentrated power you activate in your own reusable spray bottle.",
      cards: [
        { kicker: "30:500", title: "Ultra-Concentrated Yield", text: "Each 237 ml bottle dilutes at 2 tablespoons (30 ml) per 500 ml of tap water — delivering about 3.79 litres of ready-to-use professional spray.", foot: "€20 ≈ €5 per litre of ready spray" },
        { kicker: "BIO", title: "Botanical Chemistry", text: "Formulated with natural orange peel oil. Completely free of parabens, phthalates, harsh sulfates, and toxic synthetic perfumes that irritate animals.", foot: "Never tested on animals · Pet safe" },
        { kicker: "ATP", title: "Crystal Break Action", text: "Destroys the uric acid bond rather than masking it. Pets stop marking the same territory because the scent marker is eradicated down to the fiber.", foot: "Permanent odor neutralization" }
      ]
    },
    steps: {
      overline: "Easy to use",
      title: "Pour. Add Water. Shake & Spray.",
      subtitle: "Simple 3-step preparation in under thirty seconds.",
      videoLabel: "Watch: the 30-second mix",
      items: [
        { title: "Pour", text: "Measure 2 tablespoons (30 ml) of Angry Tangerine into a clean 500 ml spray bottle." },
        { title: "Add Water", text: "Top up with warm tap water to the 500 ml mark. The natural citrus oil blends evenly into an active cleaning solution." },
        { title: "Shake & Spray", text: "Shake gently and spray directly onto the affected spot. Let dwell for 10 minutes, then blot or allow to air dry." }
      ]
    },
    surfaces: {
      overline: "Nowhere to hide",
      title: "Versatile On Every Surface",
      subtitle: "Tested in busy family homes, grooming salons, and kennels.",
      link: "Select Bottle Quantity",
      tileMain: "If it stinks, we end it.",
      tileList: "Carpet · Tile · Turf · Fabric",
      items: [
        { title: "Deep Pile Carpets", desc: "Reaches deep into padding to neutralize old urine deposits." },
        { title: "Synthetic Turf & Yards", desc: "Eliminates baked-in sun odors from dog runs and balconies." },
        { title: "Tile, Hardwood & Concrete", desc: "Lifts yellowing residue without leaving greasy film behind." },
        { title: "Non-Leather Sofas & Beds", desc: "Safe for cat trees, dog beds, and vehicle backseats." }
      ]
    },
    reviews: {
      overline: "From the front lines",
      label: "Customer Feedback",
      title: "Early Bottles, Honest Words",
      bigNumber: "3.79 L",
      bigLabel: "of fresh odor-fighting power in every €20 bottle",
      note: "Illustrative sample reviews — verified reviews appear here as orders arrive",
      sample: "Sample review",
      items: [
        { text: "We have three rescue dogs in Madrid and our balcony turf was unbearable in summer heat. One dilution of Angry Tangerine wiped it out completely. The orange scent is crisp, not chemical.", name: "Sofia M. · Madrid, Spain" },
        { text: "I run a private grooming salon in Berlin. Diluting this 8 fl oz bottle into a full gallon sprayer saved us tons of money compared to supermarket ready-made sprays.", name: "Lukas K. · Berlin, Germany" }
      ],
      share: { title: "Share Your Experience", text: "Add your verified review after your first bottle arrives.", cta: "Write a Review" },
      form: { nameLabel: "Your name", textLabel: "Your review", ratingLabel: "Rating", photoLabel: "Pet photo (optional)", photoHint: "JPG or PNG, max 5 MB", submit: "Submit Review", thanks: "Thanks! Your review will appear after a quick check.", error: "Could not submit your review. Please try again." }
    },
    faq: {
      title: "Common Questions",
      subtitle: "Everything you need to know about dilution and shipping.",
      items: [
        { q: "Is it safe to use around cats and dogs?", a: "Yes. Angry Tangerine contains natural citrus terpenes without toxic additives, phthalates, or parabens. Once applied and blotted or dried, pets can freely walk on treated surfaces." },
        { q: "How much ready-to-use spray does one €20 bottle make?", a: "Dilute 2 tablespoons (30 ml) of concentrate per 500 ml of water. One 237 ml bottle makes about 3.79 litres of active odor eliminator — roughly 8 spray bottles of 500 ml." },
        { q: "Where do orders ship from?", a: "Orders are dispatched across all European countries and worldwide directly from our Spanish logistics hub at Calle Matilde Landa 9, Madrid 28029." }
      ]
    },
    compliance: {
      label: "Safety & Compliance",
      title: "Straight From The Label",
      subtitle: "Full transparency: ingredients, directions, and EU CLP safety information.",
      directionsTitle: "Directions For Use",
      directions: ["Mix 2 tbsp (30 ml) of concentrate with 500 ml of water.", "Mix well.", "Spray evenly and let air dry.", "Remove the odor source first; always test a small hidden area."],
      ingredientsTitle: "Ingredients",
      ingredients: "Water, Proprietary Encapsulated Five-Strain Bacillus Blend, Nonionic Surfactant, Sodium Citrate, D-Limonene, Orange Fragrance, Benzisothiazolinone, Linalool.",
      warningsTitle: "CLP Warnings",
      warnings: ["H226 Flammable liquid and vapour.", "H315 Causes skin irritation.", "H318 Causes serious eye irritation."],
      precautionsTitle: "Precautions",
      precautions: ["P210 Keep away from heat, hot surfaces, sparks, open flames and other ignition sources. No smoking.", "P280 Wear protective gloves and eye protection.", "P305+P351+P338 IF IN EYES: Rinse cautiously with water for several minutes. Remove contact lenses if present and easy to do. Continue rinsing.", "P403+P235 Store in a well-ventilated place. Keep cool.", "Keep away from children. Do not ingest. Avoid contact with eyes. Do not apply to animals or mix with other chemicals.", "Empty the container completely and recycle it according to local collection rules."]
    },
    order: {
      title: "Order Angry Tangerine",
      subtitle: "237 ML (8 FL OZ) Concentrated Odor Eliminator",
      perBottle: "Per Bottle",
      qtyLabel: "Quantity",
      qtyOptions: ["1 Bottle (€20) · Makes 3.79 L", "2 Bottles (€38) · Save €2 · Make 7.58 L", "3 Bottles (€54) · Save €6 · Best Value"],
      countryLabel: "Delivery Country",
      countries: ["Spain", "Germany", "France", "Netherlands", "Rest of Europe / Worldwide"],
      emailLabel: "Email for Tracking Receipt",
      emailPlaceholder: "you@domain.com",
      paymentLabel: "Payment Method",
      stripe: "Card · Stripe",
      paypal: "PayPal",
      submit: "Proceed to Secure Checkout",
      secureNote: "256-bit encrypted checkout via Stripe. We never share your details.",
      paypalNote: "PayPal is being connected — you can complete your purchase securely by card right now.",
      error: "Checkout could not be started. Please try again or email hello@angrytangerine.com.",
      loading: "Preparing secure checkout…",
      shipLabel: "Shipping",
      freeLabel: "FREE",
      totalLabel: "Total",
      stockLeft: "Only {n} bottles left in stock",
      saveBadge: "SAVE {p}%"
    },
    office: {
      title: "Direct European Support",
      text: "Questions about bulk kennel orders, commercial distribution, or delivery tracking? Reach our Madrid team directly.",
      hqTitle: "Spanish Headquarters:",
      hqAddress: "Angry Tangerine, Calle Matilde Landa 9, Madrid 28029, Spain",
      emailLabel: "Email Inquiries:",
      phoneLabel: "Customer Support:"
    },
    finalCta: {
      title: "Ready to evict the stink?",
      sub: "One bottle. 3.79 litres. Zero stink.",
      cta: "Get Angry Tangerine · €20"
    },
    footer: {
      tagline: "High-performance pet odor eliminator concentrate with natural orange oil. Madrid, Spain.",
      navTitle: "Navigation",
      langTitle: "Language Support",
      langNote: "Switch your store language anytime:",
      legalTitle: "Legal & Madrid Office",
      rights: "Angry Tangerine. All rights reserved. GMP facility manufactured · Cruelty free."
    },
    success: {
      title: "Order Received",
      checking: "Confirming your payment…",
      confirmed: "Payment confirmed. Your Angry Tangerine concentrate is being prepared in Madrid — a receipt is on its way to your inbox.",
      pending: "Payment is still processing. Refresh in a moment or contact hello@angrytangerine.com if it persists.",
      back: "Back to Store"
    },
    cancel: {
      title: "Checkout Cancelled",
      text: "No charge was made. Your bottle of Angry Tangerine is waiting whenever you are ready.",
      back: "Return to Checkout"
    }
  },
  es: {
    header: { tag: "Concentrado eliminador de olores de mascotas", buy: "Comprar 20 €" },
    nav: { bottle: "El Bote", how: "Mezcla en 3 pasos", surfaces: "Superficies", reviews: "Opiniones", faq: "Preguntas", office: "Oficina Madrid" },
    announcement: ["Envío gratis en España", "1 bote rinde 3,79 litros", "Aceite natural de naranja — seguro para mascotas", "Envíos a todo el mundo desde Madrid"],
    hero: {
      overline: "Eliminador de olores de mascotas · Concentrado",
      title: "El asesino de olores concentrado.",
      subtitle: "Funciona en cualquier superficie: alfombra, azulejo, césped artificial y tela. Nuestro concentrado de 237 ml con aceite de naranja prensado en frío se mezcla con agua del grifo para producir 3,79 litros de eliminador de olores de alta potencia, seguro para patas curiosas.",
      stat1v: "237 ML", stat1l: "Rinde 3,79 litros",
      stat2v: "100%", stat2l: "Aceite natural",
      stat3v: "20 €", stat3l: "Envío mundial",
      cta: "Pedir concentrado · 20 €",
      shipsNote: "Envíos a toda Europa y al mundo desde Madrid",
      chip: "1 bote → 3,79 L",
      check1: "Fórmula segura para mascotas", check2: "Fabricado en instalación GMP", check3: "Sin crueldad animal"
    },
    marquee: ["ELIMINA OLORES DE MASCOTAS", "HUELE A NARANJA FRESCA", "RINDE 3,79 LITROS", "SEGURO PARA LAS PATAS", "ENVÍO MUNDIAL"],
    product: {
      overline: "Lo que hace el bote",
      title: "Un bote pequeño. Potencia enorme.",
      subtitle: "Deja de pagar por enviar agua diluida entre fronteras. Angry Tangerine te da potencia concentrada que activas en tu propio pulverizador reutilizable.",
      cards: [
        { kicker: "30:500", title: "Rendimiento ultraconcentrado", text: "Cada bote de 237 ml se diluye con 2 cucharadas (30 ml) por cada 500 ml de agua del grifo, rindiendo unos 3,79 litros de spray profesional listo para usar.", foot: "20 € ≈ 5 € por litro de spray listo" },
        { kicker: "BIO", title: "Química botánica", text: "Formulado con aceite natural de cáscara de naranja. Totalmente libre de parabenos, ftalatos, sulfatos agresivos y perfumes sintéticos tóxicos que irritan a los animales.", foot: "Nunca testado en animales · Seguro para mascotas" },
        { kicker: "ATP", title: "Ruptura de cristales", text: "Destruye el enlace del ácido úrico en lugar de enmascararlo. Las mascotas dejan de marcar el mismo lugar porque el rastro de olor se erradica hasta la fibra.", foot: "Neutralización permanente del olor" }
      ]
    },
    steps: {
      overline: "Fácil de usar",
      title: "Verter. Añadir agua. Agitar y pulverizar.",
      subtitle: "Preparación sencilla en 3 pasos en menos de treinta segundos.",
      videoLabel: "Mira: la mezcla en 30 segundos",
      items: [
        { title: "Verter", text: "Mide 2 cucharadas (30 ml) de Angry Tangerine en un pulverizador limpio de 500 ml." },
        { title: "Añadir agua", text: "Rellena con agua tibia del grifo hasta la marca de 500 ml. El aceite cítrico natural se mezcla uniformemente en una solución de limpieza activa." },
        { title: "Agitar y pulverizar", text: "Agita suavemente y pulveriza directamente sobre la zona afectada. Deja actuar 10 minutos y seca con un paño o deja secar al aire." }
      ]
    },
    surfaces: {
      overline: "Sin escondites",
      title: "Versátil en cada superficie",
      subtitle: "Probado en hogares familiares concurridos, peluquerías caninas y residencias.",
      link: "Elegir cantidad de botes",
      tileMain: "Si huele mal, lo acabamos.",
      tileList: "Alfombra · Azulejo · Césped · Tela",
      items: [
        { title: "Alfombras de pelo largo", desc: "Llega al fondo del acolchado para neutralizar depósitos de orina antiguos." },
        { title: "Césped artificial y jardines", desc: "Elimina los olores acumulados por el sol en zonas de perros y balcones." },
        { title: "Azulejo, madera y hormigón", desc: "Levanta los residuos amarillentos sin dejar película grasa." },
        { title: "Sofás y camas no de cuero", desc: "Seguro para rascadores de gatos, camas de perros y asientos de coche." }
      ]
    },
    reviews: {
      overline: "Desde el frente",
      label: "Opiniones de clientes",
      title: "Primeros botes, palabras honestas",
      bigNumber: "3,79 L",
      bigLabel: "de potencia fresca contra los olores en cada bote de 20 €",
      note: "Opiniones de ejemplo ilustrativas: las opiniones verificadas aparecerán aquí",
      sample: "Opinión de ejemplo",
      items: [
        { text: "Tenemos tres perros rescatados en Madrid y el césped del balcón era insoportable en verano. Una dilución de Angry Tangerine lo eliminó por completo. El aroma a naranja es fresco, no químico.", name: "Sofia M. · Madrid, España" },
        { text: "Dirijo una peluquería canina en Berlín. Diluir este bote de 237 ml en un pulverizador de 3,79 litros nos ahorró mucho dinero frente a los sprays del supermercado.", name: "Lukas K. · Berlín, Alemania" }
      ],
      share: { title: "Comparte tu experiencia", text: "Añade tu opinión verificada cuando llegue tu primer bote.", cta: "Escribe una opinión" },
      form: { nameLabel: "Tu nombre", textLabel: "Tu opinión", ratingLabel: "Valoración", photoLabel: "Foto de tu mascota (opcional)", photoHint: "JPG o PNG, máx. 5 MB", submit: "Enviar opinión", thanks: "¡Gracias! Tu opinión aparecerá tras una rápida revisión.", error: "No se pudo enviar tu opinión. Inténtalo de nuevo." }
    },
    faq: {
      title: "Preguntas frecuentes",
      subtitle: "Todo lo que necesitas saber sobre la dilución y los envíos.",
      items: [
        { q: "¿Es seguro usarlo cerca de gatos y perros?", a: "Sí. Angry Tangerine contiene terpenos cítricos naturales sin aditivos tóxicos, ftalatos ni parabenos. Una vez aplicado y secado, las mascotas pueden pisar las superficies tratadas con total libertad." },
        { q: "¿Cuánto spray listo para usar produce un bote de 20 €?", a: "Diluye 2 cucharadas (30 ml) de concentrado por cada 500 ml de agua. Un bote de 237 ml rinde unos 3,79 litros de eliminador de olores activo: unas 8 botellas pulverizadoras de 500 ml." },
        { q: "¿Desde dónde se envían los pedidos?", a: "Los pedidos se envían a todos los países europeos y al resto del mundo directamente desde nuestro centro logístico en Calle Matilde Landa 9, Madrid 28029." }
      ]
    },
    compliance: {
      label: "Seguridad y cumplimiento",
      title: "Directamente de la etiqueta",
      subtitle: "Transparencia total: ingredientes, modo de empleo e información de seguridad CLP de la UE.",
      directionsTitle: "Modo de empleo",
      directions: ["Mezcla 2 cucharadas (30 ml) de concentrado con 500 ml de agua.", "Mezcla bien.", "Pulveriza uniformemente y deja secar al aire.", "Elimina primero la fuente del olor; prueba siempre en una zona pequeña y oculta."],
      ingredientsTitle: "Ingredientes",
      ingredients: "Agua, mezcla patentada encapsulada de cinco cepas de Bacillus, tensioactivo no iónico, citrato de sodio, D-limoneno, fragancia de naranja, benzisotiazolinona, linalool.",
      warningsTitle: "Advertencias CLP",
      warnings: ["H226 Líquidos y vapores inflamables.", "H315 Provoca irritación cutánea.", "H318 Provoca lesiones oculares graves."],
      precautionsTitle: "Precauciones",
      precautions: ["P210 Mantener alejado del calor, de superficies calientes, de chispas, de llamas abiertas y de cualquier otra fuente de ignición. No fumar.", "P280 Llevar guantes y protección ocular.", "P305+P351+P338 EN CASO DE CONTACTO CON LOS OJOS: enjuagar con agua cuidadosamente durante varios minutos. Quitar las lentes de contacto cuando estén presentes y pueda hacerse con facilidad. Proseguir con el lavado.", "P403+P235 Almacenar en un lugar bien ventilado. Mantener en lugar fresco.", "Mantener alejado de los niños. No ingerir. Evitar el contacto con los ojos. No aplicar sobre animales ni mezclar con otros productos químicos.", "Vaciar el envase completamente y reciclarlo según las normas locales de recogida (contenedor amarillo)."]
    },
    order: {
      title: "Pedir Angry Tangerine",
      subtitle: "Eliminador de olores concentrado de 237 ml",
      perBottle: "Por bote",
      qtyLabel: "Cantidad",
      qtyOptions: ["1 bote (20 €) · Rinde 3,79 litros", "2 botes (38 €) · Ahorra 2 € · Rinden 7,58 litros", "3 botes (54 €) · Ahorra 6 € · La mejor opción"],
      countryLabel: "País de entrega",
      countries: ["España", "Alemania", "Francia", "Países Bajos", "Resto de Europa / Internacional"],
      emailLabel: "Correo para el recibo de seguimiento",
      emailPlaceholder: "tu@correo.com",
      paymentLabel: "Método de pago",
      stripe: "Tarjeta · Stripe",
      paypal: "PayPal",
      submit: "Ir al pago seguro",
      secureNote: "Pago cifrado de 256 bits a través de Stripe. Nunca compartimos tus datos.",
      paypalNote: "PayPal se está conectando: ahora mismo puedes completar tu compra con tarjeta de forma segura.",
      error: "No se pudo iniciar el pago. Inténtalo de nuevo o escribe a hello@angrytangerine.com.",
      loading: "Preparando el pago seguro…",
      shipLabel: "Envío",
      freeLabel: "GRATIS",
      totalLabel: "Total",
      stockLeft: "Solo quedan {n} botes en stock",
      saveBadge: "AHORRA {p}%"
    },
    office: {
      title: "Soporte europeo directo",
      text: "¿Preguntas sobre pedidos grandes para residencias, distribución comercial o seguimiento de entregas? Contacta directamente con nuestro equipo de Madrid.",
      hqTitle: "Sede en España:",
      hqAddress: "Angry Tangerine, Calle Matilde Landa 9, Madrid 28029, España",
      emailLabel: "Consultas por email:",
      phoneLabel: "Atención al cliente:"
    },
    finalCta: {
      title: "¿Listo para expulsar los malos olores?",
      sub: "Un bote. 3,79 litros. Cero olores.",
      cta: "Conseguir Angry Tangerine · 20 €"
    },
    footer: {
      tagline: "Concentrado eliminador de olores de mascotas de alto rendimiento con aceite natural de naranja. Madrid, España.",
      navTitle: "Navegación",
      langTitle: "Idiomas",
      langNote: "Cambia el idioma de la tienda cuando quieras:",
      legalTitle: "Legal y oficina de Madrid",
      rights: "Angry Tangerine. Todos los derechos reservados. Fabricado en instalación GMP · Sin crueldad animal."
    },
    success: {
      title: "Pedido recibido",
      checking: "Confirmando tu pago…",
      confirmed: "Pago confirmado. Tu concentrado Angry Tangerine se está preparando en Madrid: el recibo va camino a tu bandeja de entrada.",
      pending: "El pago aún se está procesando. Actualiza en un momento o escribe a hello@angrytangerine.com si persiste.",
      back: "Volver a la tienda"
    },
    cancel: {
      title: "Pago cancelado",
      text: "No se ha realizado ningún cargo. Tu bote de Angry Tangerine te espera cuando estés listo.",
      back: "Volver al pago"
    }
  },
  fr: {
    header: { tag: "Concentré anti-odeurs pour animaux", buy: "Acheter · 20 €" },
    nav: { bottle: "Le Flacon", how: "Mélange en 3 étapes", surfaces: "Surfaces", reviews: "Avis", faq: "FAQ", office: "Bureau de Madrid" },
    announcement: ["Livraison gratuite en Espagne", "1 flacon donne 3,79 litres", "Huile d'orange naturelle — sans danger pour les animaux", "Expédition mondiale depuis Madrid"],
    hero: {
      overline: "Anti-odeurs pour animaux · Concentré",
      title: "L'assassin des odeurs concentré.",
      subtitle: "Efficace sur toutes les surfaces : moquette, carrelage, gazon synthétique et tissu. Notre concentré de 237 ml à l'huile d'orange pressée à froid se mélange à l'eau du robinet pour produire 3,79 litres d'éliminateur d'odeurs puissant, sans danger pour les pattes curieuses.",
      stat1v: "237 ML", stat1l: "Donne 3,79 litres",
      stat2v: "100%", stat2l: "Huile naturelle",
      stat3v: "20 €", stat3l: "Expédition mondiale",
      cta: "Commander le concentré · 20 €",
      shipsNote: "Expédié dans toute l'Europe et le monde depuis Madrid",
      chip: "1 flacon → 3,79 L",
      check1: "Formule sans danger pour les animaux", check2: "Site certifié GMP", check3: "Non testé sur les animaux"
    },
    marquee: ["ÉLIMINE LES ODEURS D'ANIMAUX", "PARFUM D'ORANGE FRAÎCHE", "DONNE 3,79 LITRES", "SANS DANGER POUR LES PATTES", "EXPÉDITION MONDIALE"],
    product: {
      overline: "Ce que fait le flacon",
      title: "Un petit flacon. Une puissance énorme.",
      subtitle: "Arrêtez de payer pour expédier de l'eau diluée. Angry Tangerine vous offre une puissance concentrée à activer dans votre propre vaporisateur réutilisable.",
      cards: [
        { kicker: "30:500", title: "Rendement ultra-concentré", text: "Chaque flacon de 237 ml se dilue à raison de 2 cuillères à soupe (30 ml) pour 500 ml d'eau du robinet — soit environ 3,79 litres de spray professionnel prêt à l'emploi.", foot: "20 € ≈ 5 € le litre de spray prêt" },
        { kicker: "BIO", title: "Chimie botanique", text: "Formulé à l'huile naturelle d'écorce d'orange. Totalement exempt de parabènes, phtalates, sulfates agressifs et parfums synthétiques toxiques qui irritent les animaux.", foot: "Jamais testé sur les animaux · Sans danger" },
        { kicker: "ATP", title: "Rupture des cristaux", text: "Détruit la liaison de l'acide urique au lieu de la masquer. Les animaux cessent de marquer le même territoire car le marqueur olfactif est éradiqué jusqu'à la fibre.", foot: "Neutralisation permanente des odeurs" }
      ]
    },
    steps: {
      overline: "Facile à utiliser",
      title: "Verser. Ajouter de l'eau. Secouer et vaporiser.",
      subtitle: "Préparation simple en 3 étapes en moins de trente secondes.",
      videoLabel: "Vidéo : le mélange en 30 secondes",
      items: [
        { title: "Verser", text: "Mesurez 2 cuillères à soupe (30 ml) d'Angry Tangerine dans un vaporisateur propre de 500 ml." },
        { title: "Ajouter l'eau", text: "Complétez avec de l'eau tiède du robinet jusqu'au repère de 500 ml. L'huile d'agrumes naturelle se mélange uniformément en une solution nettoyante active." },
        { title: "Secouer et vaporiser", text: "Secouez doucement et vaporisez directement sur la zone concernée. Laissez agir 10 minutes puis épongez ou laissez sécher à l'air." }
      ]
    },
    surfaces: {
      overline: "Aucune cachette",
      title: "Polyvalent sur chaque surface",
      subtitle: "Testé dans des foyers animés, des salons de toilettage et des chenils.",
      link: "Choisir la quantité",
      tileMain: "Si ça sent mauvais, on l'élimine.",
      tileList: "Moquette · Carrelage · Gazon · Tissu",
      items: [
        { title: "Moquettes épaisses", desc: "Atteint le fond de la sous-couche pour neutraliser les anciens dépôts d'urine." },
        { title: "Gazon synthétique et jardins", desc: "Élimine les odeurs cuites au soleil des zones pour chiens et des balcons." },
        { title: "Carrelage, parquet et béton", desc: "Élimine les résidus jaunâtres sans laisser de film gras." },
        { title: "Canapés et couchages non cuir", desc: "Sans danger pour les arbres à chat, paniers et sièges de voiture." }
      ]
    },
    reviews: {
      overline: "Depuis le front",
      label: "Avis clients",
      title: "Premiers flacons, mots sincères",
      bigNumber: "3,79 L",
      bigLabel: "de puissance anti-odeurs fraîche dans chaque flacon de 20 €",
      note: "Exemples d'avis illustratifs — les avis vérifiés apparaîtront ici",
      sample: "Avis d'exemple",
      items: [
        { text: "Nous avons trois chiens adoptés à Madrid et le gazon du balcon était insupportable en été. Une dilution d'Angry Tangerine a tout effacé. Le parfum d'orange est frais, pas chimique.", name: "Sofia M. · Madrid, Espagne" },
        { text: "Je tiens un salon de toilettage à Berlin. Diluer ce flacon de 237 ml dans un pulvérisateur de 3,79 litres nous a fait économiser beaucoup par rapport aux sprays du supermarché.", name: "Lukas K. · Berlin, Allemagne" }
      ],
      share: { title: "Partagez votre expérience", text: "Ajoutez votre avis vérifié dès l'arrivée de votre premier flacon.", cta: "Écrire un avis" },
      form: { nameLabel: "Votre nom", textLabel: "Votre avis", ratingLabel: "Note", photoLabel: "Photo de votre animal (facultative)", photoHint: "JPG ou PNG, 5 Mo max", submit: "Envoyer l'avis", thanks: "Merci ! Votre avis apparaîtra après une vérification rapide.", error: "Impossible d'envoyer votre avis. Réessayez." }
    },
    faq: {
      title: "Questions fréquentes",
      subtitle: "Tout savoir sur la dilution et la livraison.",
      items: [
        { q: "Est-ce sans danger autour des chats et des chiens ?", a: "Oui. Angry Tangerine contient des terpenes d'agrumes naturels sans additifs toxiques, phtalates ni parabènes. Une fois appliqué et séché, les animaux peuvent marcher librement sur les surfaces traitées." },
        { q: "Quelle quantité de spray prêt à l'emploi produit un flacon de 20 € ?", a: "Diluez 2 cuillères à soupe (30 ml) de concentré pour 500 ml d'eau. Un flacon de 237 ml produit environ 3,79 litres d'éliminateur d'odeurs actif, soit environ 8 vaporisateurs de 500 ml." },
        { q: "D'où partent les commandes ?", a: "Les commandes sont expédiées dans toute l'Europe et le monde depuis notre plateforme logistique espagnole, Calle Matilde Landa 9, Madrid 28029." }
      ]
    },
    compliance: {
      label: "Sécurité et conformité",
      title: "Directement depuis l'étiquette",
      subtitle: "Transparence totale : ingrédients, mode d'emploi et informations de sécurité CLP européennes.",
      directionsTitle: "Mode d'emploi",
      directions: ["Mélangez 2 cuillères à soupe (30 ml) de concentré avec 500 ml d'eau.", "Mélangez bien.", "Vaporisez uniformément et laissez sécher à l'air.", "Éliminez d'abord la source de l'odeur ; testez toujours sur une petite zone cachée."],
      ingredientsTitle: "Ingrédients",
      ingredients: "Eau, mélange exclusif encapsulé de Bacillus à cinq souches, tensioactif non ionique, citrate de sodium, D-limonène, parfum d'orange, benzisothiazolinone, linalool.",
      warningsTitle: "Avertissements CLP",
      warnings: ["H226 Liquide et vapeurs inflammables.", "H315 Provoque une irritation cutanée.", "H318 Provoque des lésions oculaires graves."],
      precautionsTitle: "Précautions",
      precautions: ["P210 Tenir à l'écart de la chaleur, des surfaces chaudes, des étincelles, des flammes nues et de toute autre source d'inflammation. Ne pas fumer.", "P280 Porter des gants de protection et un équipement de protection des yeux.", "P305+P351+P338 EN CAS DE CONTACT AVEC LES YEUX : rincer avec précaution à l'eau pendant plusieurs minutes. Enlever les lentilles de contact si la victime en porte et si elles peuvent être facilement enlevées. Continuer à rincer.", "P403+P235 Stocker dans un endroit bien ventilé. Tenir au frais.", "Tenir hors de portée des enfants. Ne pas ingérer. Éviter le contact avec les yeux. Ne pas appliquer sur les animaux ni mélanger avec d'autres produits chimiques.", "Vider complètement le récipient et le recycler selon les règles locales de collecte."]
    },
    order: {
      title: "Commander Angry Tangerine",
      subtitle: "Éliminateur d'odeurs concentré 237 ml",
      perBottle: "Par flacon",
      qtyLabel: "Quantité",
      qtyOptions: ["1 flacon (20 €) · Donne 3,79 litres", "2 flacons (38 €) · Économisez 2 € · Donnent 7,58 litres", "3 flacons (54 €) · Économisez 6 € · Meilleure offre"],
      countryLabel: "Pays de livraison",
      countries: ["Espagne", "Allemagne", "France", "Pays-Bas", "Reste de l'Europe / Monde"],
      emailLabel: "E-mail pour le reçu de suivi",
      emailPlaceholder: "vous@domaine.com",
      paymentLabel: "Moyen de paiement",
      stripe: "Carte · Stripe",
      paypal: "PayPal",
      submit: "Passer au paiement sécurisé",
      secureNote: "Paiement chiffré 256 bits via Stripe. Nous ne partageons jamais vos données.",
      paypalNote: "PayPal est en cours de connexion — vous pouvez déjà payer en toute sécurité par carte.",
      error: "Impossible de lancer le paiement. Réessayez ou écrivez à hello@angrytangerine.com.",
      loading: "Préparation du paiement sécurisé…",
      shipLabel: "Livraison",
      freeLabel: "GRATUITE",
      totalLabel: "Total",
      stockLeft: "Plus que {n} flacons en stock",
      saveBadge: "-{p} %"
    },
    office: {
      title: "Support européen direct",
      text: "Des questions sur les commandes en gros pour chenils, la distribution commerciale ou le suivi de livraison ? Contactez directement notre équipe de Madrid.",
      hqTitle: "Siège en Espagne :",
      hqAddress: "Angry Tangerine, Calle Matilde Landa 9, Madrid 28029, Espagne",
      emailLabel: "Demandes par e-mail :",
      phoneLabel: "Service client :"
    },
    finalCta: {
      title: "Prêt à expulser les mauvaises odeurs ?",
      sub: "Un flacon. 3,79 litres. Zéro odeur.",
      cta: "Obtenir Angry Tangerine · 20 €"
    },
    footer: {
      tagline: "Concentré anti-odeurs pour animaux haute performance à l'huile d'orange naturelle. Madrid, Espagne.",
      navTitle: "Navigation",
      langTitle: "Langues",
      langNote: "Changez la langue de la boutique à tout moment :",
      legalTitle: "Mentions légales et bureau de Madrid",
      rights: "Angry Tangerine. Tous droits réservés. Fabriqué en site GMP · Non testé sur les animaux."
    },
    success: {
      title: "Commande reçue",
      checking: "Confirmation de votre paiement…",
      confirmed: "Paiement confirmé. Votre concentré Angry Tangerine est préparé à Madrid — le reçu arrive dans votre boîte mail.",
      pending: "Le paiement est encore en cours. Actualisez dans un instant ou contactez hello@angrytangerine.com.",
      back: "Retour à la boutique"
    },
    cancel: {
      title: "Paiement annulé",
      text: "Aucun débit effectué. Votre flacon d'Angry Tangerine vous attend quand vous serez prêt.",
      back: "Retour au paiement"
    }
  },
  de: {
    header: { tag: "Geruchsentferner-Konzentrat für Haustiere", buy: "Kaufen · 20 €" },
    nav: { bottle: "Die Flasche", how: "3-Schritte-Mischung", surfaces: "Oberflächen", reviews: "Bewertungen", faq: "FAQ", office: "Büro Madrid" },
    announcement: ["Kostenloser Versand in Spanien", "1 Flasche ergibt 3,79 Liter", "Natürliches Orangenöl — sicher für Haustiere", "Weltweiter Versand ab Madrid"],
    hero: {
      overline: "Geruchsentferner für Haustiere · Konzentrat",
      title: "Der konzentrierte Geruchskiller.",
      subtitle: "Wirkt auf jeder Oberfläche: Teppich, Fliesen, Kunstrasen und Stoff. Unser 237-ml-Konzentrat mit kaltgepresstem Orangenöl wird mit Leitungswasser zu 3,79 Litern hochwirksamen Geruchsentferners – sicher für neugierige Pfoten.",
      stat1v: "237 ML", stat1l: "Ergibt 3,79 Liter",
      stat2v: "100%", stat2l: "Natürliches Öl",
      stat3v: "20 €", stat3l: "Weltweiter Versand",
      cta: "Konzentrat bestellen · 20 €",
      shipsNote: "Versand in ganz Europa und weltweit ab Madrid",
      chip: "1 Flasche → 3,79 L",
      check1: "Sichere Formel für Haustiere", check2: "GMP-zertifizierte Herstellung", check3: "Tierversuchsfrei"
    },
    marquee: ["BESEITIGT TIERGERÜCHE", "DUFTET NACH FRISCHEN ORANGEN", "ERGIBT 3,79 LITER", "SICHER FÜR PFOTEN", "WELTWEITER VERSAND"],
    product: {
      overline: "Was die Flasche kann",
      title: "Eine kleine Flasche. Enorme Kraft.",
      subtitle: "Hören Sie auf, verdünntes Wasser über Grenzen schicken zu bezahlen. Angry Tangerine liefert rohe, konzentrierte Kraft, die Sie in Ihrer eigenen wiederverwendbaren Sprühflasche aktivieren.",
      cards: [
        { kicker: "30:500", title: "Ultrakonzentrierte Ausbeute", text: "Jede 237-ml-Flasche wird mit 2 Esslöffeln (30 ml) pro 500 ml Leitungswasser verdünnt – ergibt etwa 3,79 Liter gebrauchsfertigen Profi-Spray.", foot: "20 € ≈ 5 € pro Liter Fertigspray" },
        { kicker: "BIO", title: "Botanische Chemie", text: "Formuliert mit natürlichem Orangenschalenöl. Völlig frei von Parabenen, Phthalaten, aggressiven Sulfaten und toxischen Kunstparfüms, die Tiere reizen.", foot: "Nie an Tieren getestet · Sicher für Haustiere" },
        { kicker: "ATP", title: "Kristallbrechung", text: "Zerstört die Harnsäurebindung statt sie zu überdecken. Haustiere hören auf, dieselbe Stelle zu markieren, weil der Duftmarker bis in die Faser beseitigt wird.", foot: "Dauerhafte Geruchsneutralisierung" }
      ]
    },
    steps: {
      overline: "Einfach anzuwenden",
      title: "Gießen. Wasser zugeben. Schütteln & sprühen.",
      subtitle: "Einfache 3-Schritte-Zubereitung in unter dreißig Sekunden.",
      videoLabel: "Video: die 30-Sekunden-Mischung",
      items: [
        { title: "Gießen", text: "2 Esslöffel (30 ml) Angry Tangerine in eine saubere 500-ml-Sprühflasche geben." },
        { title: "Wasser zugeben", text: "Bis zur 500-ml-Marke mit warmem Leitungswasser auffüllen. Das natürliche Zitrusöl vermischt sich gleichmäßig zu einer aktiven Reinigungslösung." },
        { title: "Schütteln & sprühen", text: "Sanft schütteln und direkt auf die betroffene Stelle sprühen. 10 Minuten einwirken lassen, dann abtupfen oder an der Luft trocknen lassen." }
      ]
    },
    surfaces: {
      overline: "Kein Versteck",
      title: "Vielseitig auf jeder Oberfläche",
      subtitle: "Getestet in lebhaften Familienhaushalten, Hundesalons und Zwingern.",
      link: "Flaschenmenge wählen",
      tileMain: "Wenn es stinkt, beenden wir es.",
      tileList: "Teppich · Fliesen · Kunstrasen · Stoff",
      items: [
        { title: "Hochflor-Teppiche", desc: "Dringt tief in die Polsterung ein und neutralisiert alte Urinablagerungen." },
        { title: "Kunstrasen & Gärten", desc: "Beseitigt sonneneingebrannte Gerüche aus Hundezonen und Balkonen." },
        { title: "Fliesen, Parkett & Beton", desc: "Löst gelbliche Rückstände, ohne fettigen Film zu hinterlassen." },
        { title: "Sofas & Betten ohne Leder", desc: "Sicher für Kratzbäume, Hundebetten und Autorücksitze." }
      ]
    },
    reviews: {
      overline: "Von der Front",
      label: "Kundenfeedback",
      title: "Erste Flaschen, ehrliche Worte",
      bigNumber: "3,79 L",
      bigLabel: "frische Geruchskraft in jeder 20-€-Flasche",
      note: "Illustrative Beispielbewertungen – verifizierte Bewertungen folgen hier",
      sample: "Beispielbewertung",
      items: [
        { text: "Wir haben drei Rettungshunde in Madrid und unser Balkonrasen war im Sommer unerträglich. Eine Verdünnung von Angry Tangerine hat alles beseitigt. Der Orangenduft ist frisch, nicht chemisch.", name: "Sofia M. · Madrid, Spanien" },
        { text: "Ich betreibe einen Hundesalon in Berlin. Diese 237-ml-Flasche auf 3,79 Liter verdünnt hat uns im Vergleich zu Supermarkt-Sprays viel Geld gespart.", name: "Lukas K. · Berlin, Deutschland" }
      ],
      share: { title: "Teilen Sie Ihre Erfahrung", text: "Fügen Sie Ihre verifizierte Bewertung hinzu, sobald Ihre erste Flasche ankommt.", cta: "Bewertung schreiben" },
      form: { nameLabel: "Ihr Name", textLabel: "Ihre Bewertung", ratingLabel: "Sterne", photoLabel: "Foto Ihres Haustieres (optional)", photoHint: "JPG oder PNG, max. 5 MB", submit: "Bewertung absenden", thanks: "Danke! Ihre Bewertung erscheint nach einer kurzen Prüfung.", error: "Ihre Bewertung konnte nicht gesendet werden. Bitte erneut versuchen." }
    },
    faq: {
      title: "Häufige Fragen",
      subtitle: "Alles Wichtige zu Verdünnung und Versand.",
      items: [
        { q: "Ist es sicher in der Nähe von Katzen und Hunden?", a: "Ja. Angry Tangerine enthält natürliche Zitrusterpene ohne toxische Zusätze, Phthalate oder Parabene. Nach dem Auftragen und Trocknen können Haustiere die behandelten Flächen frei betreten." },
        { q: "Wie viel gebrauchsfertiges Spray ergibt eine 20-€-Flasche?", a: "2 Esslöffel (30 ml) Konzentrat auf 500 ml Wasser verdünnen. Eine 237-ml-Flasche ergibt etwa 3,79 Liter aktiven Geruchsentferner – rund 8 Sprühflaschen à 500 ml." },
        { q: "Von wo werden Bestellungen verschickt?", a: "Bestellungen werden in alle europäischen Länder und weltweit direkt von unserem spanischen Logistikzentrum in der Calle Matilde Landa 9, Madrid 28029, versandt." }
      ]
    },
    compliance: {
      label: "Sicherheit & Compliance",
      title: "Direkt vom Etikett",
      subtitle: "Volle Transparenz: Inhaltsstoffe, Anwendung und EU-CLP-Sicherheitshinweise.",
      directionsTitle: "Anwendung",
      directions: ["2 Esslöffel (30 ml) Konzentrat mit 500 ml Wasser mischen.", "Gut vermischen.", "Gleichmäßig aufsprühen und an der Luft trocknen lassen.", "Zuerst die Geruchsquelle entfernen; immer an einer kleinen, versteckten Stelle testen."],
      ingredientsTitle: "Inhaltsstoffe",
      ingredients: "Wasser, proprietäre verkapselte Mischung aus fünf Bacillus-Stämmen, nichtionisches Tensid, Natriumcitrat, D-Limonen, Orangenduft, Benzisothiazolinon, Linalool.",
      warningsTitle: "CLP-Warnhinweise",
      warnings: ["H226 Flüssigkeit und Dampf entzündbar.", "H315 Verursacht Hautreizungen.", "H318 Verursacht schwere Augenschäden."],
      precautionsTitle: "Sicherheitshinweise",
      precautions: ["P210 Von Hitze, heißen Oberflächen, Funken, offenen Flammen sowie anderen Zündquellen fernhalten. Nicht rauchen.", "P280 Schutzhandschuhe und Augenschutz tragen.", "P305+P351+P338 BEI KONTAKT MIT DEN AUGEN: Einige Minuten lang behutsam mit Wasser spülen. Eventuell vorhandene Kontaktlinsen nach Möglichkeit entfernen. Weiter spülen.", "P403+P235 An einem gut belüfteten Ort aufbewahren. Kühl halten.", "Von Kindern fernhalten. Nicht verschlucken. Kontakt mit den Augen vermeiden. Nicht auf Tiere anwenden und nicht mit anderen Chemikalien mischen.", "Behälter vollständig entleeren und gemäß den örtlichen Sammelvorschriften recyceln."]
    },
    order: {
      title: "Angry Tangerine bestellen",
      subtitle: "Konzentrierter Geruchsentferner 237 ml",
      perBottle: "Pro Flasche",
      qtyLabel: "Menge",
      qtyOptions: ["1 Flasche (20 €) · Ergibt 3,79 Liter", "2 Flaschen (38 €) · Sparen Sie 2 € · Ergeben 7,58 Liter", "3 Flaschen (54 €) · Sparen Sie 6 € · Bestes Angebot"],
      countryLabel: "Lieferland",
      countries: ["Spanien", "Deutschland", "Frankreich", "Niederlande", "Übriges Europa / Weltweit"],
      emailLabel: "E-Mail für den Sendungsbeleg",
      emailPlaceholder: "du@domain.de",
      paymentLabel: "Zahlungsmethode",
      stripe: "Karte · Stripe",
      paypal: "PayPal",
      submit: "Zur sicheren Kasse",
      secureNote: "256-bit-verschlüsselte Kasse via Stripe. Wir geben Ihre Daten nie weiter.",
      paypalNote: "PayPal wird gerade angebunden – Sie können jetzt schon sicher per Karte zahlen.",
      error: "Die Kasse konnte nicht gestartet werden. Bitte erneut versuchen oder an hello@angrytangerine.com schreiben.",
      loading: "Sichere Kasse wird vorbereitet…",
      shipLabel: "Versand",
      freeLabel: "GRATIS",
      totalLabel: "Gesamt",
      stockLeft: "Nur noch {n} Flaschen auf Lager",
      saveBadge: "{p} % RABATT"
    },
    office: {
      title: "Direkter europäischer Support",
      text: "Fragen zu Großbestellungen für Zwinger, zum Handelsvertrieb oder zur Sendungsverfolgung? Erreichen Sie unser Madrider Team direkt.",
      hqTitle: "Spanischer Hauptsitz:",
      hqAddress: "Angry Tangerine, Calle Matilde Landa 9, Madrid 28029, Spanien",
      emailLabel: "Anfragen per E-Mail:",
      phoneLabel: "Kundensupport:"
    },
    finalCta: {
      title: "Bereit, den Gestank rauszuwerfen?",
      sub: "Eine Flasche. 3,79 Liter. Null Gestank.",
      cta: "Angry Tangerine holen · 20 €"
    },
    footer: {
      tagline: "Hochleistungs-Geruchsentferner-Konzentrat für Haustiere mit natürlichem Orangenöl. Madrid, Spanien.",
      navTitle: "Navigation",
      langTitle: "Sprachen",
      langNote: "Wechseln Sie die Shopsprache jederzeit:",
      legalTitle: "Rechtliches & Büro Madrid",
      rights: "Angry Tangerine. Alle Rechte vorbehalten. GMP-Fertigung · Tierversuchsfrei."
    },
    success: {
      title: "Bestellung eingegangen",
      checking: "Zahlung wird bestätigt…",
      confirmed: "Zahlung bestätigt. Ihr Angry-Tangerine-Konzentrat wird in Madrid vorbereitet – die Quittung ist unterwegs in Ihr Postfach.",
      pending: "Die Zahlung wird noch verarbeitet. Bitte gleich aktualisieren oder an hello@angrytangerine.com schreiben.",
      back: "Zurück zum Shop"
    },
    cancel: {
      title: "Bezahlung abgebrochen",
      text: "Es wurde nichts abgebucht. Ihre Flasche Angry Tangerine wartet, wann immer Sie bereit sind.",
      back: "Zurück zur Kasse"
    }
  },
  nl: {
    header: { tag: "Concentraat tegen dierenluchtjes", buy: "Kopen · €20" },
    nav: { bottle: "De Fles", how: "Mengen in 3 stappen", surfaces: "Oppervlakken", reviews: "Reviews", faq: "FAQ", office: "Kantoor Madrid" },
    announcement: ["Gratis verzending in Spanje", "1 fles maakt 3,79 liter", "Natuurlijke sinaasappelolie — veilig voor huisdieren", "Wereldwijde verzending vanuit Madrid"],
    hero: {
      overline: "Geurvernietiger voor huisdieren · Concentraat",
      title: "De geconcentreerde geurvernietiger.",
      subtitle: "Werkt op elk oppervlak: tapijt, tegels, kunstgras en stof. Ons concentraat van 237 ml met koudgeperste sinaasappelolie meng je met kraanwater tot 3,79 liter krachtige geurvernietiger, veilig voor nieuwsgierige pootjes.",
      stat1v: "237 ML", stat1l: "Maakt 3,79 liter",
      stat2v: "100%", stat2l: "Natuurlijke olie",
      stat3v: "€20", stat3l: "Wereldwijde verzending",
      cta: "Concentraat bestellen · €20",
      shipsNote: "Verzending door heel Europa en wereldwijd vanuit Madrid",
      chip: "1 fles → 3,79 L",
      check1: "Veilige formule voor huisdieren", check2: "GMP-gecertificeerde productie", check3: "Diervriendelijk"
    },
    marquee: ["VERWIJDERT DIERENLUCHTJES", "RUIKT NAAR VERSSE SINAASAPPELS", "MAAKT 3,79 LITER", "VEILIG VOOR POOTJES", "WERELDWIJDE VERZENDING"],
    product: {
      overline: "Wat de fles doet",
      title: "Eén klein flesje. Enorme kracht.",
      subtitle: "Stop met betalen voor het verzenden van verdund water over grenzen. Angry Tangerine geeft je rauwe, geconcentreerde kracht die je activeert in je eigen herbruikbare spuitfles.",
      cards: [
        { kicker: "30:500", title: "Ultrageconcentreerde opbrengst", text: "Elke fles van 237 ml verdun je met 2 eetlepels (30 ml) per 500 ml kraanwater — goed voor zo'n 3,79 liter gebruiksklare professionele spray.", foot: "€20 ≈ €5 per liter kant-en-klare spray" },
        { kicker: "BIO", title: "Botanische chemie", text: "Samengesteld met natuurlijke sinaasappelschillenolie. Volledig vrij van parabenen, ftalaten, agressieve sulfaten en giftige synthetische parfums die dieren irriteren.", foot: "Nooit op dieren getest · Veilig voor huisdieren" },
        { kicker: "ATP", title: "Kristalbreuk", text: "Breekt de urinezuurbinding af in plaats van te maskeren. Huisdieren stoppen met het markeren van dezelfde plek omdat de geurmarkering tot in de vezel is verwijderd.", foot: "Permanente geurneutralisatie" }
      ]
    },
    steps: {
      overline: "Makkelijk in gebruik",
      title: "Gieten. Water toevoegen. Schudden & sprayen.",
      subtitle: "Eenvoudige bereiding in 3 stappen in minder dan dertig seconden.",
      videoLabel: "Kijk: de mix in 30 seconden",
      items: [
        { title: "Gieten", text: "Meet 2 eetlepels (30 ml) Angry Tangerine af in een schone spuitfles van 500 ml." },
        { title: "Water toevoegen", text: "Vul aan met warm kraanwater tot de 500-ml-markering. De natuurlijke citrusolie mengt gelijkmatig tot een actieve reinigingsoplossing." },
        { title: "Schudden & sprayen", text: "Zachtjes schudden en direct op de plek sprayen. 10 minuten laten intrekken, daarna deppen of aan de lucht laten drogen." }
      ]
    },
    surfaces: {
      overline: "Geen schuilplaats",
      title: "Veelzijdig op elk oppervlak",
      subtitle: "Getest in drukke gezinshuizen, trimsalons en kennels.",
      link: "Kies het aantal flessen",
      tileMain: "Als het stinkt, maken we er een einde aan.",
      tileList: "Tapijt · Tegels · Kunstgras · Stof",
      items: [
        { title: "Hoogpolige tapijten", desc: "Drongt diep door tot in de vulling om oude urineafzettingen te neutraliseren." },
        { title: "Kunstgras & tuinen", desc: "Verwijdert ingebrande zonluchtjes uit hondenrennen en balkons." },
        { title: "Tegels, hardhout & beton", desc: "Verwijdert vergeelde resten zonder vettig laagje." },
        { title: "Banken & manden zonder leer", desc: "Veilig voor krabpalen, hondenmanden en achterbanken." }
      ]
    },
    reviews: {
      overline: "Van het front",
      label: "Klantfeedback",
      title: "Eerste flessen, eerlijke woorden",
      bigNumber: "3,79 L",
      bigLabel: "frisse geurkracht in elke fles van €20",
      note: "Illustratieve voorbeeldreviews — geverifieerde reviews verschijnen hier",
      sample: "Voorbeeldreview",
      items: [
        { text: "We hebben drie geredde honden in Madrid en ons balkongras was ondraaglijk in de zomerhitte. Eén verdunning van Angry Tangerine maakte er helemaal een einde aan. De sinaasappelgeur is fris, niet chemisch.", name: "Sofia M. · Madrid, Spanje" },
        { text: "Ik run een trimsalon in Berlijn. Deze fles van 237 ml verdunnen tot 3,79 liter bespaarde ons veel geld vergeleken met kant-en-klare sprays uit de supermarkt.", name: "Lukas K. · Berlijn, Duitsland" }
      ],
      share: { title: "Deel jouw ervaring", text: "Voeg je geverifieerde review toe zodra je eerste fles arriveert.", cta: "Schrijf een review" },
      form: { nameLabel: "Je naam", textLabel: "Je review", ratingLabel: "Beoordeling", photoLabel: "Foto van je huisdier (optioneel)", photoHint: "JPG of PNG, max. 5 MB", submit: "Review versturen", thanks: "Bedankt! Je review verschijnt na een snelle controle.", error: "Je review kon niet worden verstuurd. Probeer opnieuw." }
    },
    faq: {
      title: "Veelgestelde vragen",
      subtitle: "Alles wat je moet weten over verdunnen en verzenden.",
      items: [
        { q: "Is het veilig te gebruiken rond katten en honden?", a: "Ja. Angry Tangerine bevat natuurlijke citrusterpenen zonder giftige toevoegingen, ftalaten of parabenen. Na aanbrengen en drogen kunnen huisdieren vrij over behandelde oppervlakken lopen." },
        { q: "Hoeveel gebruiksklare spray maakt één fles van €20?", a: "Verdun 2 eetlepels (30 ml) concentraat per 500 ml water. Eén fles van 237 ml maakt ongeveer 3,79 liter actieve geurvernietiger — zo'n 8 spuitflessen van 500 ml." },
        { q: "Vanaf waar worden bestellingen verzonden?", a: "Bestellingen worden naar alle Europese landen en wereldwijd verzonden vanuit ons Spaanse logistieke centrum aan de Calle Matilde Landa 9, Madrid 28029." }
      ]
    },
    compliance: {
      label: "Veiligheid & compliance",
      title: "Rechtstreeks van het etiket",
      subtitle: "Volledige transparantie: ingrediënten, gebruiksaanwijzing en EU CLP-veiligheidsinformatie.",
      directionsTitle: "Gebruiksaanwijzing",
      directions: ["Meng 2 eetlepels (30 ml) concentraat met 500 ml water.", "Goed mengen.", "Gelijkmatig sprayen en aan de lucht laten drogen.", "Verwijder eerst de geurbron; test altijd op een kleine, verborgen plek."],
      ingredientsTitle: "Ingrediënten",
      ingredients: "Water, gepatenteerde ingekapselde mix van vijf Bacillus-stammen, niet-ionische oppervlakteactieve stof, natriumcitraat, D-limoneen, sinaasappelgeur, benzisothiazolinone, linalool.",
      warningsTitle: "CLP-waarschuwingen",
      warnings: ["H226 Ontvlambare vloeistof en damp.", "H315 Veroorzaakt huidirritatie.", "H318 Veroorzaakt ernstig oogletsel."],
      precautionsTitle: "Voorzorgsmaatregelen",
      precautions: ["P210 Verwijderd houden van warmte, hete oppervlakken, vonken, open vuur en andere ontstekingsbronnen. Niet roken.", "P280 Beschermende handschoenen en oogbescherming dragen.", "P305+P351+P338 BIJ CONTACT MET DE OGEN: voorzichtig afspoelen met water gedurende een aantal minuten; contactlenzen verwijderen indien mogelijk; blijven spoelen.", "P403+P235 Op een goed geventileerde plaats bewaren. Koel bewaren.", "Buiten bereik van kinderen houden. Niet inslikken. Contact met de ogen vermijden. Niet op dieren aanbrengen en niet mengen met andere chemicaliën.", "De verpakking volledig leegmaken en recyclen volgens de lokale inzamelregels."]
    },
    order: {
      title: "Angry Tangerine bestellen",
      subtitle: "Geconcentreerde geurvernietiger 237 ml",
      perBottle: "Per fles",
      qtyLabel: "Aantal",
      qtyOptions: ["1 fles (€20) · Maakt 3,79 liter", "2 flessen (€38) · Bespaar €2 · Maken 7,58 liter", "3 flessen (€54) · Bespaar €6 · Beste keuze"],
      countryLabel: "Land van levering",
      countries: ["Spanje", "Duitsland", "Frankrijk", "Nederland", "Overig Europa / Wereldwijd"],
      emailLabel: "E-mail voor de ontvangstbevestiging",
      emailPlaceholder: "jij@domein.nl",
      paymentLabel: "Betaalmethode",
      stripe: "Kaart · Stripe",
      paypal: "PayPal",
      submit: "Naar beveiligde kassa",
      secureNote: "256-bit versleutelde kassa via Stripe. We delen je gegevens nooit.",
      paypalNote: "PayPal wordt nog gekoppeld — je kunt nu al veilig met kaart betalen.",
      error: "De kassa kon niet worden gestart. Probeer opnieuw of mail hello@angrytangerine.com.",
      loading: "Beveiligde kassa wordt voorbereid…",
      shipLabel: "Verzending",
      freeLabel: "GRATIS",
      totalLabel: "Totaal",
      stockLeft: "Nog maar {n} flessen op voorraad",
      saveBadge: "{p}% KORTING"
    },
    office: {
      title: "Directe Europese support",
      text: "Vragen over grote kennelbestellingen, commerciële distributie of leveringstracking? Bereik ons team in Madrid direct.",
      hqTitle: "Spaans hoofdkantoor:",
      hqAddress: "Angry Tangerine, Calle Matilde Landa 9, Madrid 28029, Spanje",
      emailLabel: "Vragen per e-mail:",
      phoneLabel: "Klantenservice:"
    },
    finalCta: {
      title: "Klaar om de stank eruit te gooien?",
      sub: "Eén fles. 3,79 liter. Nul stank.",
      cta: "Angry Tangerine halen · €20"
    },
    footer: {
      tagline: "Krachtig concentraat tegen dierenluchtjes met natuurlijke sinaasappelolie. Madrid, Spanje.",
      navTitle: "Navigatie",
      langTitle: "Talen",
      langNote: "Wijzig de winkelttaal wanneer je wilt:",
      legalTitle: "Juridisch & kantoor Madrid",
      rights: "Angry Tangerine. Alle rechten voorbehouden. GMP-geproduceerd · Diervriendelijk."
    },
    success: {
      title: "Bestelling ontvangen",
      checking: "Je betaling wordt bevestigd…",
      confirmed: "Betaling bevestigd. Je Angry Tangerine-concentraat wordt in Madrid klaargemaakt — het ontvangstbewijs is onderweg naar je inbox.",
      pending: "De betaling wordt nog verwerkt. Vernieuw zo even of mail hello@angrytangerine.com als het aanhoudt.",
      back: "Terug naar de winkel"
    },
    cancel: {
      title: "Betaling geannuleerd",
      text: "Er is niets afgeschreven. Je fles Angry Tangerine wacht wanneer je er klaar voor bent.",
      back: "Terug naar de kassa"
    }
  }
};
